import React from 'react';

const PagoErr: React.FC = () => {
    return (
        <div className="pago-err">
            <h1>Ha ocurrido un error</h1>
            <p style={{ textAlign: 'left', padding: "0px 30px"}}>Lamentablemente ha habido un error al procesar el pago de la reserva.</p>
            <p style={{ textAlign: 'left', padding: "0px 30px"}}>Por favor, intentelo nuevamente <a href="https://www.hankyplanet.com">aquí</a> o contacte con el centro llamando al 666 222 269</p>
            <p style={{ textAlign: 'left', padding: "0px 30px"}}>Disculpa las molestias.</p>
        </div>
    );
};

export default PagoErr;
